import { setupDesktopNavBarExperimentBucketing } from './desktop_nav_bar';
import { setupMobileNavBarExperimentBucketing } from './mobile_nav_bar';

export function setupExperimentsBucketing() {
  setupMobileNavBarExperimentBucketing();
  setupDesktopNavBarExperimentBucketing();
}
